import { createTheme } from '@mui/material/styles';

import '@fontsource/inter/300.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/700.css';


const colorSchemes = {
  mainColor : "#613BFF",
  darkColor : "#6251ED",
  mainContrastColor: "#EFEEFC",
  backgroundColor: "#E5E7EB",
  disabledColor: "#CFCFCD",
  disableActionColor:"#A096F4"
}

const theme = createTheme({
  typography: {
    fontFamily: [
      'Inter', // Primary font
      'Roboto', // Fallback for Material UI components
      'sans-serif',
    ].join(','),
  },
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: '20px !important',
          '& fieldset': {
            borderRadius: '20px', // Apply desired border radius globally
            border: '.8px solid ' + colorSchemes.mainColor,
          },
          '&:hover fieldset': {
            border: '1px solid ' + colorSchemes.mainColor + '!important',
          },
          '&.Mui-focused fieldset': {
            borderColor: '1px solid ' + colorSchemes.mainColor + '!important',
          }
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          '&::placeholder': {
            color: 'grey', // Your desired placeholder color
            opacity: 0.6, // Ensure full opacity in Firefox
          },
        },
      }
    },
    MuiPickersInputBase: {
      styleOverrides: {
        root: {
          borderRadius: '20px !important',
          '&.Mui-focused fieldset': {
            border: '2px solid ' + colorSchemes.mainColor + '!important',
          },
          '& fieldset': {
            border: '.8px solid ' + colorSchemes.mainColor + '!important',
          },
          '&:hover fieldset': {
            border: '1px solid ' + colorSchemes.mainColor + '!important',
          }
        }
      }
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          '&.Mui-focused fieldset': {
            borderColor: '5px solid ' + colorSchemes.mainColor + '!important',
          }
        }
      }
    }
  },
  cssVariables: true,
  palette: {
     action: {
      disabledBackground: colorSchemes.disableActionColor,
      //disabled: "#FFF",
    },
    background: {
      default: colorSchemes.backgroundColor,
    },
    primary: {
      main: colorSchemes.mainColor,//'rgba(var(--primary-color))' #6251ED
      dark: colorSchemes.darkColor,
      contrastContainer:colorSchemes.mainContrastColor,
      disabled: colorSchemes.disabledColor,
      contrasts:{
        peach:"#FF8FA2",
        blue:"#96DEFE",
        green:"#89E68B",
        yellow:"#FFCE85",
        violet:"#A89CFF",
        grey:"#CFCBCB"
      }
    }
  }
});

export default theme;